import * as React from 'react';
const throttle = require('lodash.throttle');

export interface IActionWithHorizontalScrollProps {
  children: React.ReactChild;
  action(): void;
}

export class ActionWithHorizontalScroll extends React.Component<IActionWithHorizontalScrollProps, {}> {
  private container = React.createRef<HTMLDivElement>();

  public componentDidMount() {
    /* istanbul ignore else */
    if (this.container.current) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.container.current.firstChild!.addEventListener('scroll', this.onScroll);
    }
  }

  public componentWillUnmount() {
    /* istanbul ignore else */
    if (this.container.current) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.container.current.firstChild!.removeEventListener('scroll', this.onScroll);
    }
  }

  public render() {
    return <div ref={this.container}>{this.props.children}</div>;
  }

  private isBlockInView = (scrollLeft: number, scrollWidth: number, ratio: number) => {
    return scrollLeft + window.innerWidth >= scrollWidth * ratio;
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private scrollHandler = (e: any) => {
    const { scrollLeft, scrollWidth } = e.target;

    if (this.isBlockInView(scrollLeft, scrollWidth, 2 / 3)) {
      this.props.action();

      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.container.current!.firstChild!.removeEventListener('scroll', this.onScroll);
    }
  };

  private onScroll = throttle(this.scrollHandler, 150);
}
